import moment from "moment"

export const dateForServer = (date: Date): moment.Moment => {
  return moment(date).utc()
}

export function formatDateForApi(date: any) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function formatDateTimeForApi(date: any) {
  return date.toISOString()
}

export const showCustomDate = (date: Date | string | undefined, format: string, fallback: string | boolean = "-"): string | boolean => {
  return date && moment(date).isValid()
    ? moment.utc(date).local().format(format)
    : fallback
}

export const showDateTime = (date: Date | string | undefined | null, fallbackString: string = "-"): string => {
  return date && moment(date).isValid()
    ? moment.utc(date).local().format("YYYY-MM-DD HH:mm")
    : fallbackString
}

export const showDate = (date: Date | string | undefined | null, fallbackString: string = "-"): string => {
  return date && moment(date).isValid()
    ? moment.utc(date).local().format("YYYY-MM-DD")
    : fallbackString
}
